/*document.addEventListener("readystatechange", function (event) {
  if (event.target.readyState === 'complete') {

//Fading headers
document.querySelectorAll('.fade-down')

let fadingLettersObserverOptions = {
  rootMargin: '0px',
  threshold: 0.15
}
var fadingLettersObserver = new IntersectionObserver(fadingLettersObserverCallback, fadingLettersObserverOptions);
function fadingLettersObserverCallback(entries, fadingLettersObserver) {
  entries.forEach(entry => {
    if(entry.isIntersecting) {
        entry.target.querySelectorAll('h2').forEach(elm => {
            elm.classList.add('animate-in');
        });
        fadingLettersObserver.unobserve(entry.target)
    } else {
    }
  });
};

if (document.querySelector('.fade-down.videos')) {
  var target1 = document.querySelector('.fade-down.videos')
  fadingLettersObserver.observe(target1);
}
if (document.querySelector('.fade-down.music')) {
  var target2 = document.querySelector('.fade-down.music')
  fadingLettersObserver.observe(target2);
}
if (document.querySelector('.fade-down.social')) {
  var target3 = document.querySelector('.fade-down.social')
  fadingLettersObserver.observe(target3);
} else {
  console.log("no targets");
}



  let bulbObserverOptions = {
    rootMargin: '0px',
    threshold: 0.15
  }
  var bulbObserver = new IntersectionObserver(bulbObserverCallback, bulbObserverOptions);
  function bulbObserverCallback(entries, bulbObserver) {
    entries.forEach(entry => {
      if(entry.isIntersecting) {
          entry.target.querySelectorAll('.bulb').forEach(elm => {
              elm.classList.add('animate-bulb');
          });
          bulbObserver.unobserve(entry.target)
      } else {
      }
    });
  };

if (document.querySelector('#if-video .bulb-container')) {
  var bulbTarget1 = document.querySelector('#if-video .bulb-container');
  bulbObserver.observe(bulbTarget1);
}
if (document.querySelector('#if-music .bulb-container')) {
  var bulbTarget2 = document.querySelector('#if-music .bulb-container');
  bulbObserver.observe(bulbTarget2);
  console.log('if-music')
}


  }

});*/
document.addEventListener("readystatechange", function (event) {
  if (event.target.readyState === 'complete') {
    const currentUrl = window.location.href;
    const industry = sessionStorage.getItem('industry');
    var vidsArray = [...document.querySelectorAll('slideshow-component, .rich-text, .bio, .industry-music, .press-container, .social-stats-container, .player-container-outter')];
    if (currentUrl.indexOf("passwordpage") > -1) {
      if (industry === "Indy2023") {
        vidsArray.forEach(elm => {
          elm.style = "display:block !important";
        })
      } else {
        vidsArray.forEach(elm => {
          elm.remove();
        })
      }
    }
  }
});
